






































import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import {number} from '@coders-tm/vue-number-format';
import DNumberbox from "@/components/DNumberbox/numberbox.vue";
import NumberSpan from '@/components/InputComponents/number-span.vue';
import { format2DigitsVariant } from "@/utils/numbers";
import _ from 'lodash';

import PresetService from '@/services/user_preset_service';
import { aggregate_periods } from '@/constants';

@Component({
  name: 'TotalBlockInputs',
  components: {
    number,
    DNumberbox,
    NumberSpan
  }
})
export default class  extends Vue {
  @PropSync('presets') public localPresets!: any;
  @Prop({default: {}}) public portion!: any;
  @Prop({default: {}}) public secondaryPortion!: any;
  @Prop({default: false}) public initiated!: boolean;
  @Prop({default: false}) public showSecondaryCut!: boolean;
  @Prop({default: false}) public showPowerColumns!: boolean;
  @Prop({default: false}) public strictTariffCalc!: boolean;

  @Prop() public periodName!: string;
  @Prop() public blockAccept!: any;
  @Prop() public blockId!: string;

  @Prop({default: () => {
      return {
        first: false,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false,
      }
    }}) public rowVisible!: any;



  get cssVars() {
    return {
      '--width': PresetService.tableWidth + 'px'
    }
  }

  get route() {
    return this.$route.name;
  }

  get show_volume() {
    if((this.localPresets.losses_show_volume && this.route === 'losses')  || (this.localPresets.buy_show_volume && this.route === 'buy') ||
    (this.localPresets.sale_show_volume && this.route === 'sale') || (this.localPresets.transport_cost_show_volume && this.route === 'transport_cost') ||
    (this.localPresets.transport_gain_show_volume && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost() {
    if((this.localPresets.buy_show_cost && this.route === 'buy') || (this.localPresets.sale_show_cost && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost_delta() {
    if((this.localPresets.buy_show_cost_delta && this.route === 'buy') || (this.localPresets.sale_show_cost_delta && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_delta && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_delta && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price() {
    if((this.localPresets.buy_show_price && this.route === 'buy') || (this.localPresets.sale_show_price && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get rowHeight() {
    let count = 2;
    for(let key in this.rowVisible) {
      if(this.rowVisible[key]) count += 1;
    }
    return {height: `${(25 * count) + 22}px`,}
  }

  get rowKeysList() {
    return ['total', 'first', 'steam_total', 'second', 'third', 'fourth', 'fifth', 'sixth'].map((rowName, idx) => {
      let className: string = '';
      let visible = false;
      // Признак суммирующей строки
      if (rowName === 'total' || rowName === 'steam_total') {
        if (!this.aggregate) {
          className = 'auto-calculate';
        } else {
          className = 'aggregateTotal';
        }
        visible = true;
      } else {
        // Признак четной - нечетной строки
        if (this.aggregate) {
          className = (idx % 2) ? 'aggregateColorEven' : 'aggregateColorOdd';
        } else {
          className = (idx % 2) ? 'showColorEven' : 'showColorOdd';
        }
        visible = this.rowVisible[rowName];
      }
      return { rowName, visible, className }
    });
  }

  get columnsValueList() {
    return [
      { name: 'vol_te', visible: this.show_volume },
      { name: 'price_te', visible: this.show_price },
      { name: 'cost_te', visible: this.show_cost },
      { name: 'cost_delta_te', visible: this.show_cost_delta },
      { name: 'vol_power', visible: this.show_volume && this.showPowerColumns },
      { name: 'price_power', visible: this.show_price && this.showPowerColumns },
      { name: 'cost_power', visible: this.show_cost && this.showPowerColumns },
      { name: 'cost_delta_power', visible: this.show_cost_delta && this.showPowerColumns },
      { name: 'price_total', visible: this.show_price && this.showPowerColumns },
      { name: 'cost_total', visible: this.show_cost && this.showPowerColumns },
    ]
  }

  get aggregate() {
    return aggregate_periods.hasOwnProperty(this.periodName);
  }

  get isReadOnly() {
    return this.strictTariffCalc;
  }

  mounted() {

  }

  @Watch('portion.first', { deep: true })
  @Watch('portion.second', { deep: true })
  @Watch('portion.third', { deep: true })
  @Watch('portion.fourth', { deep: true })
  @Watch('portion.fifth', { deep: true })
  @Watch('portion.sixth', { deep: true })
  seekChanges() {
    if(this.initiated) {
      const changes = {block: this.blockId, period: this.periodName}
      this.$emit('changes', changes);
    }
  }

  formatReadOnlyValue(val: number, colName: string) {
    if (colName.split("_")[0] === 'vol' || colName.split("_")[0] === 'cost') {
      return this.changeFormat(val)
    } else {
      return this.$options.filters?.numberFormat(val, 2) || format2DigitsVariant.format(val);
    }
  }

  changeFormat(data:any) {
    return this.$options.filters?.numberFormat(data, 2) || this.$options.filters?.numberFormat(data, 0);
  }

}
